var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelStatDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 103,
    viewBox: "0 0 550 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.5C0 2.5 36.2998 33.4646 50.5 44.5C64.7002 55.5354 77 69.9869 77 69.9869C77 69.9869 92.0646 100.673 116.124 78.0919C140.183 55.5111 156.788 37.2058 156.788 37.2058C156.788 37.2058 183.868 14.2513 212.438 37.2058C241.008 60.1602 252.313 67.4198 252.313 67.4198C252.313 67.4198 272.765 82.1588 304.434 69.9869C336.103 57.8151 341.433 54.9609 341.433 54.9609C341.433 54.9609 371.209 45.6432 396.041 57.8151C420.873 69.9869 440.255 74.1941 440.255 74.1941C440.255 74.1941 469.102 80.7736 482.954 62.2886C496.806 43.8037 525.567 -3.2241 550 0.17499C549.902 18.6592 549.968 77.9468 549.992 97.0253C549.996 100.342 547.308 103 543.991 103H5.99999C2.68629 103 0 100.314 0 97V2.5Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B0037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F80303"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelStatDanger);
export default __webpack_public_path__ + "static/media/panel-stat-danger.66bf95c08801930168bc343212ed660c.svg";
export { ForwardRef as ReactComponent };